import { devLog } from '../utils/dev-log';

/**
 * Executes background warm-up tasks for quoting-brain on app boot:
 * 1. Seed business bio from pricing if missing
 * 2. Warm tenant instance owner cache
 */
export function runBackgroundBootWarmup(): void {
    // 1. Business bio seeding
    try {
        const schedule = (typeof window !== 'undefined' && window.requestIdleCallback) || ((fn: () => void) => setTimeout(fn, 2000));
        schedule(async () => {
            try {
                const { seedBusinessBioFromPricing } = await import('./bio-service');
                const bio = await seedBusinessBioFromPricing();
                if ((bio as any)?.seeded_from_pricing) {
                    devLog('[QM] Business bio seeded from pricing record (narrative fields empty - user or AI to fill)');
                }
            } catch (err: any) {
                console.warn('[QM] Business bio seeding failed (non-fatal):', err?.message);
            }
        });
    } catch (err: any) {
        console.warn('[QM] Business bio seeding scheduling failed:', err?.message);
    }

    // 2. Warm instance-owner cache
    (async () => {
        try {
            const { getInstanceOwner } = await import('./tenant-resolver');
            await getInstanceOwner();
        } catch { /* non-fatal */ }
    })();
}
